export default __webpack_public_path__ + "static/Vol 3 - TA 4 - FCA-DS (with appendices)-e6a2add961ebc28d271fc700f831efbb.pdf";